export default __webpack_public_path__ + "static/media/plus-circle.d6a18027.svg";